import UploadRegimeProofError from './UploadRegimeProofError';
class RegimeProofInvalidFileType extends UploadRegimeProofError {
    constructor(options) {
        super('Fiscal Regime proof has invalid type', options);
    }
}
export default RegimeProofInvalidFileType;
